import React, {Fragment, useContext} from "react";
import {useParams} from 'react-router-dom';
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {Constants} from "../common/Constants";
import {ActivityMaterial} from "../../types/ActivityMaterial";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ActivityMaterialForm} from "./ActivityMaterialForm";

type UpdateActivityMaterialPageRouteParams = {
    activityMaterialId: string;
}

export let UpdateActivityMaterialPage = function () {
    const context = useContext(GlobalContext);
    const params = useParams<UpdateActivityMaterialPageRouteParams>();
    const materialsListPath = `/${Constants.routes.settings.pathSegment}/activity-materials`;

    function fetchActivityMaterial(activityMaterialId: string) {
        return ApiUtility.getActivityMaterials().then(function (activityMaterialsList: ActivityMaterial[]) {
            return activityMaterialsList.find(function (activityMaterial) {
                return '' + activityMaterial.id === '' + activityMaterialId;
            });
        });
    }

    const modelUpdateEngine = useModelUpdateEngine(
        fetchActivityMaterial,
        ApiUtility.updateActivityMaterial,
        '' + params.activityMaterialId,
        'material',
        () => context.navigator.navigateTo(materialsListPath),
        {}
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().model} renderer={() => (
                <ActivityMaterialForm
                    save={modelUpdateEngine.updateModel}
                    activityMaterial={modelUpdateEngine.dataStore.data().model}
                    isNew={false}
                />
            )}/>
        </Fragment>
    );
};
